module.exports = __webpack_public_path__ + "static/media/Disaster.46686828.png";